export const breadthFirstSearch = function (root, getChildren, predicate) {
    const queue = [root]
    var node = null
    while ((node = queue.shift())) {
        if (predicate(node)) {
            return node
        }
        var children = getChildren(node)
        if (!children) {
            continue
        }
        if (!Array.isArray(children)) {
            children = [children]
        }
        children.nonNull().forEach((child) => queue.push(child))
    }
    return null
}

export const traverseTree = function (root, getChildren, operation) {
    breadthFirstSearch(root, getChildren, (node) => {
        operation(node)
        return false
    })
}

export default {
    breadthFirstSearch
}
